const NotAllowCustGroup = () =>
  import('@/views/main/helper/notAllowCustGroup/NotAllowCustGroup.vue')
export default {
  path: '/main/helper/notAllowCustGroup',
  name: 'NotAllowCustGroup',
  component: NotAllowCustGroup
}
